

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.By6EupPp.js","_app/immutable/chunks/disclose-version.BiGnJ2-v.js","_app/immutable/chunks/runtime.r6XFBCAP.js","_app/immutable/chunks/legacy.5Vd76dO9.js","_app/immutable/chunks/render.0QIQfn1h.js","_app/immutable/chunks/svelte-head.D2TQESsa.js","_app/immutable/chunks/entry.c71XrGpa.js","_app/immutable/chunks/index-client.D85crPKC.js","_app/immutable/chunks/index.BLdWbiDd.js"];
export const stylesheets = [];
export const fonts = [];
